import React, { useState, useEffect } from 'react';
import { Table, Pagination, Button, Form, ButtonGroup } from 'react-bootstrap';
import { Filter, EyeFill, PencilFill, TrashFill, Search } from 'react-bootstrap-icons';
import FiltrosProductos from './filtroProductos';
import EditProductoModal from './editProductoModal';
import VerProductoModal from './verProductoModal';
import { handleDelete, handleDeleteMultiple } from '../utils/AlertsProductos'; // Nueva función para eliminar múltiples productos
import APIserver from '../../../../api/axiosConfig';
import { Link } from 'react-router-dom';

// Función para formatear valores como moneda COP
const formatCop = (value) => {
  return value?.toLocaleString('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }) || '$0';
};

function TablaProductos() {
  const [showFilters, setShowFilters] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editShow, setShowEdit] = useState(false);
  const [verShow, setShowVer] = useState(false);
  const [selectedProducto, setSelectedProducto] = useState({});
  const [productos, setProductos] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isFiltering, setIsFiltering] = useState(false);
  //const [isLoading, setIsLoading] = useState(true);
  const [selectedProducts, setSelectedProducts] = useState([]); // Estado para productos seleccionados

  useEffect(() => {
    fetchProductos(currentPage, rowsPerPage);
  }, [currentPage, rowsPerPage]);

  const fetchProductos = async (page, limit, filters = {}) => {
    let url = `/api/productos`;
    const params = new URLSearchParams(filters);

    if (params.toString()) {
      url += `?${params.toString()}`;
      setIsFiltering(true);
    } else {
      url += `?page=${page}&limit=${limit}`;
      setIsFiltering(false);
    }

    try {
      const response = await APIserver.get(url);
      setProductos(response.data.products);
      const totalCount = response.data.totalCount;
      setTotalPages(Math.ceil(totalCount / limit));
    } catch (error) {
      console.error('Error al obtener los productos:', error);
    }
  };

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allProductIds = productos.map((producto) => producto.idProducto);
      setSelectedProducts(allProductIds);
    } else {
      setSelectedProducts([]);
    }
  };

  const handleSelectProduct = (idProducto) => {
    setSelectedProducts((prevSelected) =>
      prevSelected.includes(idProducto)
        ? prevSelected.filter((id) => id !== idProducto)
        : [...prevSelected, idProducto]
    );
  };
  const handleDeleteMultipleProducts = async () => {
    await handleDeleteMultiple(selectedProducts, () => {
      setSelectedProducts([]);
      fetchProductos(currentPage, rowsPerPage);
    });
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handleEditClose = () => {
    setShowEdit(false);
    fetchProductos(currentPage, rowsPerPage); // Volver a cargar la lista de productos después de editar
  };

  const handleEditShow = (producto) => {
    setSelectedProducto({
      ...producto
    });
    setShowEdit(true);
  };

  const handleVerClose = () => setShowVer(false);

  const handleVerShow = (producto) => {
    setSelectedProducto(producto);
    setShowVer(true);
  };

  const handleDeleteProducto = async (productId) => {
    await handleDelete(productId, () => {
      if (currentPage > totalPages) {
        setCurrentPage(totalPages);
      } else {
        fetchProductos(currentPage, rowsPerPage);
      }
    });
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleFilterChange = (filters) => {
    fetchProductos(1, rowsPerPage, filters);
  };

  const renderPaginationItems = () => {
    const items = [];
    const pageRangeDisplayed = 5;
    let startPage = Math.max(1, currentPage - Math.floor(pageRangeDisplayed / 2));
    let endPage = Math.min(totalPages, startPage + pageRangeDisplayed - 1);

    if (endPage - startPage < pageRangeDisplayed - 1) {
      startPage = Math.max(1, endPage - pageRangeDisplayed + 1);
    }

    if (startPage > 1) {
      items.push(<Pagination.First key="first" onClick={() => handlePageChange(1)} />);
    }

    if (currentPage > 1) {
      items.push(<Pagination.Prev key="prev" onClick={() => handlePageChange(currentPage - 1)} />);
    }

    for (let number = startPage; number <= endPage; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    if (currentPage < totalPages) {
      items.push(<Pagination.Next key="next" onClick={() => handlePageChange(currentPage + 1)} />);
    }

    if (endPage < totalPages) {
      items.push(<Pagination.Last key="last" onClick={() => handlePageChange(totalPages)} />);
    }

    return items;
  };

  return (
    <div style={{ boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)" }}>
      {selectedProducts.length > 0 && (
        <div className="text-center mb-2">
          <Button variant="danger" onClick={handleDeleteMultipleProducts}>
            Eliminar {selectedProducts.length} Productos
          </Button>
        </div>
      )}
      <Table responsive className='text-center align-middle border'>
        <thead>
          <tr>
            <th colSpan={11}>
              <div className='d-flex justify-content-between align-items-center'>
                <div className='d-flex flex-wrap'>
                  <Button variant='link' size='sm' onClick={toggleFilters} title='Filtrar'>
                    <Filter className='m-0 text-danger' size={20} />
                  </Button>
                </div>
                <div>
                  <Form.Select
                    className='ms-2'
                    value={rowsPerPage}
                    onChange={handleChangeRowsPerPage}
                  >
                    <option value='5'>5</option>
                    <option value='10'>10</option>
                    <option value='20'>20</option>
                    <option value='50'>50</option>
                  </Form.Select>
                </div>
              </div>
              <div className={`filter-options ${showFilters ? 'show' : ''}`}>
                <FiltrosProductos onFilterChange={handleFilterChange} />
              </div>
            </th>
          </tr>
          <tr>
            <th>
              <Form.Check
                type="checkbox"
                onChange={handleSelectAll}
                checked={selectedProducts.length === productos.length && productos.length > 0}
              />
            </th>
            <th>Ref</th>
            <th>Nombre</th>
            <th>Stock</th>
            <th>P.Compra</th>
            <th>P.Unidad</th>
            <th>P.xMayor</th>
            <th>Ganancia</th>
            <th>Ganancia Total</th>
            <th>Total</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {productos.map(producto => {
            const ganancia = producto.precioMayor - producto.precioCompra;
            const gananciaTotal = ganancia * producto.stock;
            const totalProductos = producto.precioMayor * producto.stock;
            
            return (
              <tr key={producto.idProducto}>
                <td>
                  <Form.Check
                    type="checkbox"
                    onChange={() => handleSelectProduct(producto.idProducto)}
                    checked={selectedProducts.includes(producto.idProducto)}
                  />
                </td>
                <td>{producto.referencia}</td>
                <td>{producto.nombre}</td>
                <td>{producto.stock}</td>
                <td>{formatCop(producto.precioCompra)}</td>
                <td>{formatCop(producto.precioVenta)}</td>
                <td>{formatCop(producto.precioMayor)}</td>
                <td>{formatCop(ganancia)}</td>
                <td>{formatCop(gananciaTotal)}</td>
                <td>{formatCop(totalProductos)}</td>
                <td>
                  <ButtonGroup aria-label='action-button'>
                    <Button variant='link' className='text-dark' title='ver producto' onClick={() => handleVerShow(producto)}>
                      <EyeFill size={18} />
                    </Button>
                    <Button variant='link' className='text-warning' title='editar producto' onClick={() => handleEditShow(producto)}>
                      <PencilFill size={18} />
                    </Button>
                    <Button variant='link' className='text-danger' title='eliminar producto' onClick={() => handleDeleteProducto(producto.idProducto)}>
                      <TrashFill size={18} />
                    </Button>
                    <Link to={`./Imagenes/${producto.referencia}/`}>
                      <Button variant='link' className='text-primary' title='ver imagenes producto'>
                        <Search size={18} />
                      </Button>
                    </Link>
                  </ButtonGroup>
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          {!isFiltering && (
            <tr>
              <td colSpan={11}>
                <div className='d-flex justify-content-center align-items-center'>
                  <Pagination>
                    {renderPaginationItems()}
                  </Pagination>
                </div>
              </td>
            </tr>
          )}
        </tfoot>
      </Table>

      <EditProductoModal show={editShow} handleClose={handleEditClose} producto={selectedProducto} fetchProductos={fetchProductos} />
      <VerProductoModal show={verShow} handleClose={handleVerClose} productoId={selectedProducto.idProducto} />
    </div>
  );
}

export default TablaProductos;
